import { FC } from 'react'
import { DetailField, DetailFields, DetailPanel } from '../../../../../../components'
import { FaturaList } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  data?: FaturaList
  isLoading?: boolean
}

export const FaturaExpandedRow: FC<IProps> = ({ data, isLoading }) => {
  const { t } = useT()

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes da fatura…'>
      {data && (
        <DetailFields>
          <DetailField label={t('cols.valor_faturado')} value={data.valorFormatado} />
          <DetailField label={t('cols.valor_pagar')} value={data.valorProfissionaisFormatado} />
          <DetailField label={t('cols.valor_adicional')} value={data.valorAdicionalFormatado} />
          <DetailField
            label={t('observacao.label')}
            value={data.observacao}
            emptyLabel={t('common.none', { name: t('observacao.label.lowercase') })}
            wide
          />
        </DetailFields>
      )}
    </DetailPanel>
  )
}
